import firebase from 'firebase';
import globalConfig, {isLogin, translateError} from './util/globalConfig';
import axios from 'axios';
import { Miniapp } from './util/Miniapp';



export function trigetGoogleAnaystEvent(type,name,post) {
    ga('send', 'event', type, post, name);
}

export function init(appId) {
    return new Promise(function (resolve, reject) {
        const firebaseApp = globalConfig.firebaseApps[appId];
        firebaseApp.auth().onAuthStateChanged(function (user) {
            if (user) {
                // User is signed in.
                checkWhetherLoggedInUserIsValidOrNot(firebaseApp).then(function (response) {
                    resolve(Object.assign({user: user}, response));
                }).catch(function (error) {
                    reject(error);
                });
            } else {
                localStorage.clear();
                resolve({
                    status: 'Login'
                });
            }
        });
    });

}

function checkWhetherLoggedInUserIsValidOrNot(firebaseApp) {
    return new Promise(function (resolve, reject) {
        Miniapp.getAccessToken().then(async function (accessToken) {
            if(accessToken) {
                initAuthInterceptor(globalConfig.appId, globalConfig.web_apiKey);
                let obj = {
                    status: true
                };
                resolve(obj);
            } else {
                let obj = {
                    message: 'Sorry, You are unauthorized for this application',
                    status: '403',
                    data: ''
                };
                reject(obj);
            }
          
        }).catch(function (err) { 
            let obj = {
                message: 'Sorry, You are unauthorized for this application',
                status: '403',
                data: ''
            };
            reject(obj);
        });
        // firebaseApp.auth().currentUser.getIdToken(false).then(function (idToken) {
        //     let token = idToken;
        //     let obj = {
        //         token_type: 'firebase-token',
        //         token: token
        //     };
        //     axios.post(globalConfig.BackendUrl.url + '/account/auth', obj, {
        //         headers: {
        //             'Grpc-Metadata-app-id': globalConfig.appId,
        //             'Grpc-Metadata-web-api-key': globalConfig.web_apiKey
        //         }
        //     }).then(function (response) {
        //         if (response.data.user_profile) {
        //             localStorage.setItem(globalConfig.appId + '_user', JSON.stringify(response.data.user_profile));
        //             localStorage.setItem(globalConfig.appId + '_quiz_role', 'quizPlayer');
        //             localStorage.setItem(globalConfig.appId + '_access_token', response.data.access_token);
        //             localStorage.setItem(globalConfig.appId + '_uID', response.data.user_profile.user_id);
        //             localStorage.setItem(globalConfig.appId + '_time', Number(new Date().getTime()) + Number(response.data.expire_in) - Number(600000));
        //             initAuthInterceptor(globalConfig.appId, globalConfig.web_apiKey);
        //             let obj = {
        //                 status: true
        //             };
        //             resolve(obj);
        //         } else {
        //             let obj = {
        //                 message: 'Sorry, You are unauthorized for this application',
        //                 status: '403',
        //                 data: ''
        //             };
        //             reject(obj);
        //         }
        //     }).catch(function (secondError) {
        //         reject(translateError(secondError));
        //     });
        // }).catch(function (error) {
        //     // Handle error
        //     reject(translateError(error));
        // });
    });
}

export async function initAuthInterceptor(appId, apiKey) {
    axios.interceptors.request.use(async function (config) {
        await Miniapp.initialize();
        config.headers['Authkey'] = 'khulja-s!m-s1m';
        config.headers['Grpc-Metadata-app-id'] = appId;
        config.headers['Grpc-Metadata-web-api-key'] = apiKey;
        let token = await Miniapp.getAccessToken();
        if(token != '')
            config.headers['grpc-metadata-authorization'] = 'mini-app-bearer ' + token;
        return config;
    }, function (error) {
        return Promise.reject(error);
    });
    return initAuthResponseInterceptor();

}

function initAuthResponseInterceptor() {
    // axios.interceptors.response.use(function (response) {
    //     return response;
    // }, function (error) {
    //     const originalRequest = error.config;
    //     if (error.response.status === 401) {
    //         originalRequest._retry = true;
    //         const firebaseApp = globalConfig.firebaseApps[appId];
    //         checkWhetherLoggedInUserIsValidOrNot(firebaseApp).then(
    //             function () {
    //                 return axios(originalRequest);
    //             }
    //         ).catch(function (error) {
    //             return translateError(error);
    //         });
    //     }
    //     return Promise.reject(error);
    // });
}